<template lang="pug">
  v-layout#wrapper(align-center justify-center row fill-height)
    v-card.mt-6.mt-md-0(style='max-width: 100%; width: 250px;')
      v-card-text.text-center
        v-avatar.mt-n12.mb-2.elevation-12.white(style='height: 88px; min-width: 88px; width: 88px;')
          v-icon(large style="font-size:88px" color="primary") fas fa-user-circle
        .title
          | Beechoo Origin
        
        FormWrapper.pt-2(type="auth")
          template( v-slot:default="props")
            AuthForm(
              :model="props.model",
              :validate="props.validate",
              :valid="props.valid",
            )

</template>

<script>
import AuthForm from '@/components/forms/Auth.vue';
import FormWrapper from '@/components/wrapper/FormWrapper.vue';

export default {
  components: {
    AuthForm,
    FormWrapper,
  },
};
</script>

<style lang="stylus" scoped>
#wrapper
  // background url(https://source.unsplash.com/P1qyEf1g0HU)
  height 100vh
  width 100vw
  background-size cover
  background-position center
  background-repeat no-repeat
  background-attachment fixed
</style>
